export type OnboardingOrigin = "clinician" | "patient";

export const ONBOARDING_ORIGIN_KEY = "onboarding_origin";

export function setOnboardingOrigin(origin: OnboardingOrigin) {
  localStorage.setItem(ONBOARDING_ORIGIN_KEY, origin);
}

export function getOnboardingOrigin(searchParams?: URLSearchParams): OnboardingOrigin {
  const oShort = searchParams?.get("o");
  if (oShort === "p") return "patient";
  if (oShort === "c") return "clinician";

  const fromQuery = searchParams?.get("origin");
  if (fromQuery === "patient") return "patient";
  if (fromQuery === "clinician") return "clinician";

  const fromStorage = localStorage.getItem(ONBOARDING_ORIGIN_KEY);
  if (fromStorage === "patient") return "patient";
  return "clinician";
}

/** Origem do onboarding a partir do path curto do e-mail (/auth/v/p| c/...) ou query legada. */
export function resolveVerificationOrigin(
  pathOriginSlug: string | undefined,
  searchParams?: URLSearchParams,
): OnboardingOrigin {
  if (pathOriginSlug === "p") return "patient";
  if (pathOriginSlug === "c") return "clinician";
  return getOnboardingOrigin(searchParams);
}

export function getOnboardingPathByOrigin(origin: OnboardingOrigin): "/onboarding" | "/onboarding_paciente" {
  return origin === "patient" ? "/onboarding_paciente" : "/onboarding";
}
